import CommonService from '../../../../services/commonService';
import React from 'react';
import getIcons from '../../functions/getIcons/getIcons';

const TarapacaTitle = props => {
	const operator = CommonService.getLocal('op');

	return (
		<div
			id={props.id}
			className={`themes-theme-two-title new-container  ${props.className}`}
			style={props.containerStyle ? props.containerStyle : { margin: '35px auto' }}
		>
			{props.leftLine && getIcons('Line', props.operator) && (
				<div className="line left">
					<img src={getIcons('Line', props.operator)} alt="" />
				</div>
			)}
			{props.smallHeading && (
				<div
					className="bold-text mb5"
					style={{
						color:
							props.operator &&
								props.operator.color_codes &&
								props.operator.color_codes.primary_text_color
								? props.operator.color_codes.primary_text_color
								: null,
						marginTop: operator && operator.operator_name === 'biaggini' ? '20px' : '10px',
					}}
				>
					{props.smallHeading}
				</div>
			)}
			{props.rightLine && getIcons('Line', props.operator) && (
				<div className="line right">
					<img src={getIcons('Line', props.operator)} alt="" />
				</div>
			)}
		</div>
	);
};

export default TarapacaTitle;



// WEBPACK FOOTER //
// ./src/features/themes/Cormarbus/common/CormarbusTitle.js